/*
  Quiet background videos (<video data-aw-video data-src="…" poster="…">).
  - Nothing downloads until the video is near the screen: phones only pay for it if
    someone scrolls there. The poster shows first.
  - It plays only while it is actually visible (also inside a swiped-away slide, since
    the observer respects scrolling containers) and pauses when it leaves.
  - Reduced motion: never plays on its own; the viewer gets the controls instead.
*/
(function () {
  if (window.__awVideo) return;
  window.__awVideo = true;

  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function load(video) {
    if (video.dataset.src && !video.getAttribute('src')) {
      video.setAttribute('src', video.dataset.src);
      video.load();
    }
  }

  function setUp(video) {
    if (video.dataset.awVideoReady) return;
    video.dataset.awVideoReady = '1';
    video.muted = true;
    if (calm.matches) {
      video.controls = true;
      video.preload = 'none';
      video.addEventListener('play', () => load(video), { once: true });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      load(video);
      video.play().catch(() => {});
      return;
    }
    // Start fetching a little before it arrives…
    new IntersectionObserver(
      (entries, observer) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          load(video);
          observer.disconnect();
        }
      },
      { rootMargin: '400px 0px' }
    ).observe(video);
    // …and play only while at least a quarter of it is on screen
    new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            load(video);
            video.play().catch(() => {});
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    ).observe(video);
  }

  const scan = (scope) => scope.querySelectorAll('video[data-aw-video]').forEach(setUp);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  window.AwVideo = { scan };
})();
